import Glide from '@glidejs/glide'


// npm: https://www.npmjs.com/package/@glidejs/glide
// docs: https://glidejs.com/docs
// npm install @glidejs/glide

// import "@glidejs/glide/dist/css/glide.core.min.css";
// import "@glidejs/glide/dist/css/glide.theme.min.css";

// <!-- Required Core stylesheet -->
// <link rel="stylesheet" href="node_modules/@glidejs/glide/dist/css/glide.core.min.css">

// <!-- Optional Theme stylesheet -->
// <link rel="stylesheet" href="node_modules/@glidejs/glide/dist/css/glide.theme.min.css"


// Expected structure:
// <div class="glide">
//   <div class="glide__track" data-glide-el="track">
//     <ul class="glide__slides">
//       <li class="glide__slide">0</li>
//       <li class="glide__slide">1</li>
//       <li class="glide__slide">2</li>
//     </ul>
//   </div>
// </div>

// track type: {HTMLElement}

//     Usage: Holds reference to the [data-glide-el="track"] element

// wrapper type: {HTMLElement}

//     Usage: Holds reference to the [data-glide-el="track"] element





export function initializeSliders() {

	// LOGO SLIDERS.
	// They're just groups, with a classname of 'logos-in-a-row'.
	// let perViewCountLogoSliders = 2
	// const logoSliders = document.querySelectorAll('.is-style-inz-carousel----not-in-use')
	// if (logoSliders) {

	// 	let optionsLogoSlider = {
	// 		type: 'carousel',
	// 		autoplay: 4000,
	// 		startAt: 0,
	// 		perView: perViewCountLogoSliders,
	// 		// focusAt: 0,

	// 		// rewind: true,
	// 		perTouch: 3,
	// 		// bound: true,
	// 		// peek: {
	// 		// 	before: 100,
	// 		// 	after: 50
	// 		// },
	// 		// gap: 20,
	// 		gap: 0,
	// 		breakpoints: {
	// 			520: {
	// 				perView: 2
	// 			},
	// 			640: {
	// 				perView: 3
	// 			},
	// 			1080: {
	// 				perView: 4
	// 			},
	// 			1280: {
	// 				perView: 5
	// 			},
	// 			2400: {
	// 				perView: 6
	// 			} // perView is desktop-first iso mobile first, read: below 2400, show 6 perView.
	// 		}
	// 	}

	// 	logoSliders.forEach(logoSlider => {
	// 		console.log(logoSlider)
	// 		// Get slideable elements
	// 		const slides = logoSlider.querySelectorAll(":scope > *")

	// 		// Continue if we have more slides than perViewCount
	// 		if (slides && slides.length > perViewCountLogoSliders) {

	// 			// Prepare necessary HTML.
	// 			let glideEL = document.createElement('div')
	// 			glideEL.classList.add('glide', 'glide--carousel--grouped-items')

	// 			let trackEl = document.createElement('div')
	// 			trackEl.setAttribute('data-glide-el', "track")
	// 			trackEl.classList.add('glide__track')

	// 			let trackList = document.createElement('div')
	// 			trackList.classList.add('glide__slides', 'is-layout-flex')

	// 			// Move the slideable elements to the tracklist.
	// 			slides.forEach(slide => {
	// 				trackList.appendChild(slide)
	// 			})

	// 			trackEl.appendChild(trackList)
	// 			glideEL.appendChild(trackEl)
	// 			logoSlider.replaceChildren(glideEL)

	// 			// Initialize slider.
	// 			let glideLogoSlider = new Glide(logoSlider, optionsLogoSlider);
	// 			// glideLogoSlider.on('resize', function() {

	// 			// })
	// 			glideLogoSlider.mount();
	// 		}
	// 	})
	// }

	// let sliderToewijzingen = new Glide('.cipt-slider--toewijzingen', optionsKandidaten );
	// sliderToewijzingen.mount();

	// let sliderHuurders = new Glide('.cipt-slider--huurders', optionsKandidaten );
	// sliderHuurders.mount();




	// Image galleries.
	// Native WP Gallery blocks, with style 'Carousel' (is-style-carousel).
	let perViewCountGalleries = 3


	const imgGalleries = document.querySelectorAll('.is-style-inz-carousel')
	if (imgGalleries) {

		imgGalleries.forEach(imgGallery => {
			// console.log(imgGallery)


			// Get the number of grid columns, if applicable.

			// A grid? Need to sniff applied CSS :/
			if (imgGallery.classList.contains('is-layout-grid')) {

				const computedElementStyles = window.getComputedStyle(imgGallery);
				if (computedElementStyles.getPropertyValue("grid-template-columns").includes( "repeat(2," )) {
					perViewCountGalleries = 2;
				} else if (computedElementStyles.getPropertyValue("grid-template-columns").includes( "repeat(3," )) {
					perViewCountGalleries = 3;
				} else if (computedElementStyles.getPropertyValue("grid-template-columns").includes( "repeat(4," )) {
					perViewCountGalleries = 4;
				} else if (computedElementStyles.getPropertyValue("grid-template-columns").includes( "repeat(5," )) {
					perViewCountGalleries = 5;
				} else if (computedElementStyles.getPropertyValue("grid-template-columns").includes( "repeat(6," )) {
					perViewCountGalleries = 6;
				}

			} else if (imgGallery.classList.contains('wp-block-gallery')) {
				if (imgGallery.classList.contains('columns-1')) {
					perViewCountGalleries = 1;
				} else if (imgGallery.classList.contains('columns-2')) {
					perViewCountGalleries = 2;
				} else if (imgGallery.classList.contains('columns-4')) {
					perViewCountGalleries = 4;
				} else if (imgGallery.classList.contains('columns-5')) {
					perViewCountGalleries = 5;
				} else if (imgGallery.classList.contains('columns-6')) {
					perViewCountGalleries = 6;
				}
			}

			// if (imgGallery.classList.contains('inz-blocks-grid--large-blocks')) {
			// 	perViewCountGalleries = 2;
			// } else if(imgGallery.classList.contains('inz-blocks-grid--small-blocks')) {
			// 	perViewCountGalleries = 5;
			// } else if (imgGallery.classList.contains('inz-blocks-grid')) {
			// 	// Fallback for 3, 2-1 and 1-3 columns.
			// 	perViewCountGalleries = 3;
			// }


			// console.log(perViewCountGalleries);


			let optionsGallerySlider = {
				type: 'slider',
				// autoplay: 3000,
				// autoplay: false,
				startAt: 0,
				perView: perViewCountGalleries,
				rewind: true,
				perTouch: perViewCountGalleries,
				bound: true,
				gap: 30,
				breakpoints: {
					420: {
						perView: 1
					},
					600: {
						perView: 2
					},
					900: {
						perView: 3 > perViewCountGalleries ? perViewCountGalleries : 3
					},
					2400: {
						perView: perViewCountGalleries
					} // perView is desktop-first iso mobile first, read: below 2400, show 6 perView.
				}
			}


			// Get slideable elements
			const slides = imgGallery.querySelectorAll(":scope > *")
			// console.log(slides.length);

			// Continue if we have more slides than perViewCount
			if (slides && slides.length > perViewCountGalleries) {


				// Prepare necessary HTML.
				let glideEL = document.createElement('div')
				glideEL.classList.add('glide', 'glide--slider--gallery')

				let trackEl = document.createElement('div')
				trackEl.setAttribute('data-glide-el', "track")
				trackEl.classList.add('glide__track')

				let trackList = document.createElement('div')
				trackList.classList.add('glide__slides')

				// Setup controls
				// @see https://glidejs.com/docs/setup/

				// Schema value of the data-glide-dir attribute must be in special format:
				// > - Move one forward
				// < - Move one backward
				// ={i} - Go to zero-based {i} slide (eq. '=1', will go to second slide)
				// >> - Rewinds to the end (last slide)
				// << - Rewinds to the start (first slide)

				// <div class="glide__bullets" data-glide-el="controls[nav]">
				// 	<button class="glide__bullet" data-glide-dir="=0"></button>
				// 	<button class="glide__bullet" data-glide-dir="=1"></button>
				// 	<button class="glide__bullet" data-glide-dir="=2"></button>
				// </div>

				let glideBulletsEL = document.createElement('div')
				glideBulletsEL.classList.add('glide__bullets')
				// glideBulletsEL.dataset.glide-el = 'controls[nav]' // mag niet, koppelteken. gebruik setAttr
				glideBulletsEL.setAttribute('data-glide-el', 'controls[nav]')

				// Move the slideable elements to the tracklist AND to the bullets.
				let slideIndex = 0;
				slides.forEach(slide => {
					trackList.appendChild(slide)

					// let glideBulletEL = slide.cloneNode(true)
					// glideBulletEL.classList.add('glide__bullet')
					// glideBulletEL.setAttribute('data-glide-dir', '=' + slideIndex)
					// glideBulletsEL.appendChild(glideBulletEL)
					slideIndex++
				})

				// <div class="glide__arrows" data-glide-el="controls">
				// 	<button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button>
				// 	<button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>
				// </div>
				let glideArrowsEL = document.createElement('div')
				glideArrowsEL.classList.add('glide__arrows')
				glideArrowsEL.setAttribute('data-glide-el', 'controls')

				let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
				let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
				use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_chevron_right');
				svg.append(use)
				svg.classList.add('svg-icon')

				let glideArrowLeftEL = document.createElement('button')
				glideArrowLeftEL.classList.add('glide__arrow', 'glide__arrow--left')
				glideArrowLeftEL.setAttribute('data-glide-dir', '<')
				svg.setAttribute('aria-label', 'vorige afbeelding')
				glideArrowLeftEL.append(svg)
				glideArrowsEL.appendChild(glideArrowLeftEL)

				let svg2 = svg.cloneNode(true)

				let glideArrowRightEL = document.createElement('button')
				glideArrowRightEL.classList.add('glide__arrow', 'glide__arrow--right')
				glideArrowRightEL.setAttribute('data-glide-dir', '>')
				svg2.setAttribute('aria-label', 'volgende afbeelding')
				glideArrowRightEL.append(svg2)
				glideArrowsEL.appendChild(glideArrowRightEL)


				trackEl.appendChild(trackList)
				glideEL.appendChild(trackEl)
				// glideEL.appendChild(glideBulletsEL)
				glideEL.appendChild(glideArrowsEL)
				imgGallery.replaceChildren(glideEL)


				function updateGlideHeightVar() {
					// Fix positioning arrows (50% from track iso 50% from the whole glide incl bullets below).
					let trackElHeight = trackEl.offsetHeight;
					// console.log(trackElHeight)
					glideEL.style.setProperty("--glide-px-height", trackElHeight + 'px');
				}

				// Initialize slider & prep events-to-be
				let glideGallerySlider = new Glide(imgGallery, optionsGallerySlider);
				glideGallerySlider.on('build.after', function () {
					imgGallery.classList.add('glide--mounted')
					imgGallery.classList.remove('glide--is-calculating')
				// 	updateGlideHeightVar()
				})
				// glideGallerySlider.on('resize', function() {
				// 	updateGlideHeightVar()
				// })
				glideGallerySlider.mount();



			} else {
				// Glide will not be mounted (too few items)
				imgGallery.classList.add('glide--will-not-mount')
			}
		})
	}


}







// let parser = new DOMParser()


// // prepare svg code.
// function getSVGIconString( name ) {
// 	let SVGIconArray = {
// 		close: '<svg id="mabo-close" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.4407 14.8331L0 27.2738L2.26304 29.5369L14.7037 17.0962L27.6075 30L29.8705 27.7369L16.9668 14.8331L29.5369 2.26304L27.2738 0L14.7037 12.5701L2.5967 0.463079L0.333665 2.72611L12.4407 14.8331Z" fill="currentColor"/></svg>',
// 		arrowRight: '<svg id="mabo-arrow-right" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"><path d="M49.0607 13.0607C49.6464 12.4749 49.6464 11.5251 49.0607 10.9393L39.5147 1.3934C38.9289 0.807615 37.9792 0.807615 37.3934 1.3934C36.8076 1.97919 36.8076 2.92894 37.3934 3.51472L45.8787 12L37.3934 20.4853C36.8076 21.0711 36.8076 22.0208 37.3934 22.6066C37.9792 23.1924 38.9289 23.1924 39.5147 22.6066L49.0607 13.0607ZM-1.31134e-07 13.5L48 13.5L48 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z" fill="currentColor"/></svg>',
// 		arrowLeft: '<svg id="mabo-arrow-left" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"><path d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807609 11.0711 0.807608 10.4853 1.39339L0.93934 10.9393ZM50 10.5L2 10.5L2 13.5L50 13.5L50 10.5Z" fill="currentColor"/></svg>'
// 	}
// 	return SVGIconArray[ name ]
// }


// export default function createWpBlockGallerySlider( wpBlockGallery ) {
// 	const html = document.querySelector('html')

// 	// #1 Prepare the gallery block html.
// 	const glideEl = wpBlockGallery
// 	const glideSlides = glideEl.querySelector('ul')
// 	const glideSlideElements = glideEl.querySelectorAll('li.blocks-gallery-item')
// 	const glideInnerContainer = document.createElement('div')
// 	glideInnerContainer.classList.add('cipt-wp-gallery__inner-container')

// 	const glideTrack = document.createElement('div')
// 	glideTrack.classList.add('cipt-wp-gallery__track')
// 	glideTrack.setAttribute('data-glide-el', 'track')

// 	glideEl.insertBefore(glideInnerContainer, glideSlides)
// 	glideInnerContainer.appendChild(glideTrack)
// 	glideTrack.appendChild(glideSlides)

// 	// Update classes: swap the default gallery classes to avoid (future) CSS.
// 	glideEl.classList.remove('wp-block-gallery')
// 	glideEl.classList.add('cipt-wp-gallery', 'wp-block-cipt-wp-gallery')

// 	glideSlides.classList.remove('blocks-gallery-grid')
// 	glideSlides.classList.add('cipt-wp-gallery__slides')

// 	Array.prototype.forEach.call( glideSlideElements, function( glideSlide ) {
// 		glideSlide.classList.remove('blocks-gallery-item')
// 		glideSlide.classList.add('cipt-wp-gallery__slide')
// 	});

// 	// Default Glide structure
// 	// <div class="glide">
// 	// <div class="glide__track" data-glide-el="track">
// 	// <ul class="glide__slides">
// 	// <li class="glide__slide">0</li>
// 	// <li class="glide__slide">1</li>
// 	// <li class="glide__slide">2</li>
// 	// </ul>
// 	// </div>
// 	// </div>

// 	// Schema value of the data-glide-dir attribute must be in special format:
// 	// > - Move one forward
// 	// < - Move one backward
// 	// ={i} - Go to zero-based {i} slide (eq. '=1', will go to second slide)
// 	// >> - Rewinds to the end (last slide)
// 	// << - Rewinds to the start (first slide)

// 	// Controls
// 	// <div data-glide-el="controls">
// 	// <button data-glide-dir="<<">Start</button>
// 	// <button data-glide-dir=">>">End</button>
// 	// </div>

// 	// Arrows
// 	// <div class="glide__arrows" data-glide-el="controls">
// 	// <button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button>
// 	// <button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>
// 	// </div>

// 	const glideArrows = document.createElement('div')
// 	glideArrows.classList.add('cipt-wp-gallery__arrows')
// 	glideArrows.setAttribute('data-glide-el', 'controls')

// 	const glideArrowLeft = document.createElement('button')
// 	glideArrowLeft.classList.add('cipt-wp-gallery__arrow', 'cipt-wp-gallery__arrow--left')
// 	glideArrowLeft.setAttribute('data-glide-dir', '<')
// 	glideArrowLeft.setAttribute('aria-label', 'Previous slide')
// 	// const btnLabelPrev = document.createTextNode('<svg class="svg svg-icon" viewbox="0 0 50 24" preserveAspectRatio="xMidYMid meet"><use xlink:href="#mabo-header-logo"></use></svg>')
// 	const iconArrowLeft = parser.parseFromString( getSVGIconString('arrowLeft'), "image/svg+xml").documentElement;
// 	glideArrowLeft.appendChild(iconArrowLeft)

// 	const glideArrowRight = document.createElement('button')
// 	glideArrowRight.classList.add('cipt-wp-gallery__arrow', 'cipt-wp-gallery__arrow--right')
// 	glideArrowRight.setAttribute('data-glide-dir', '>')
// 	glideArrowRight.setAttribute('aria-label', 'Next slide')
// 	// const btnLabelNext = document.createTextNode('<svg class="svg svg-icon" viewbox="0 0 50 24" preserveAspectRatio="xMidYMid meet"><use xlink:href="#mabo-header-logo"></use></svg>')
// 	const iconArrowRight = parser.parseFromString( getSVGIconString('arrowRight'), "image/svg+xml").documentElement;
// 	glideArrowRight.appendChild(iconArrowRight)

// 	glideArrows.appendChild(glideArrowLeft)
// 	glideArrows.appendChild(glideArrowRight)
// 	glideInnerContainer.appendChild(glideArrows)

// 	// Bullets
// 	// <div class="glide__bullets" data-glide-el="controls[nav]">
// 	// <button class="glide__bullet" data-glide-dir="=0"></button>
// 	// <button class="glide__bullet" data-glide-dir="=1"></button>
// 	// <button class="glide__bullet" data-glide-dir="=2"></button>
// 	// </div>

// 	// #2 Setup slider options
// 	let peekAfter = 0;
// 	let peekAfterTablet = 0;
// 	if ( glideEl.classList.contains("alignfull") ) {
// 		// Only allow right peek when the slider is full width
// 		peekAfter = 350;
// 		peekAfterTablet = 200;
// 	}

// 	const glide = new Glide(glideInnerContainer, {
// 		type: 'slider',
// 		startAt: 0,
// 		perView: 2,
// 		focusAt: 0,
// 		bound: true,
// 		gap: 14,
// 		perTouch: 2,
// 		rewind: true,
// 		// animationDuration: 200,
// 		// rewindDuration: 400,
// 		peek: {
// 			before: 0,
// 			after: peekAfter
// 		},
// 		throttle: 25,
// 		breakpoints: {
// 			1045: {
// 				perView: 2,
// 				peek: {
// 					before: 0,
// 					after: peekAfterTablet
// 				},
// 			},
// 			760: {
// 				perView: 1,
// 				peek: {
// 					before: 0,
// 					after: 0
// 				},
// 			}
// 		},
// 		classes: {
// 			direction: {
// 				ltr: 'cipt-wp-gallery--ltr',
// 				rtl: 'cipt-wp-gallery--rtl'
// 			},
// 			slider: 'cipt-wp-gallery--slider',
// 			carousel: 'cipt-wp-gallery--carousel',
// 			swipeable: 'cipt-wp-gallery--swipeable',
// 			dragging: 'cipt-wp-gallery--dragging',
// 			cloneSlide: 'cipt-wp-gallery__slide--clone',
// 			activeNav: 'cipt-wp-gallery__bullet--active',
// 			activeSlide: 'cipt-wp-gallery__slide--active',
// 			disabledArrow: 'cipt-wp-gallery__arrow--disabled'
// 		}
// 	})

// 	// Start with slide #0: don't show the left arrow
// 	glide.on('mount.after', function() {
// 		glideInnerContainer.classList.add('at-first-slide')
// 	})
// 	glide.on('run.after', function() {
// 		if ( 0 === glide.index ) {
// 			glideInnerContainer.classList.add('at-first-slide')
// 		} else {
// 			glideInnerContainer.classList.remove('at-first-slide')
// 		}
// 	})

// 	// Add lightbox HTML
// 	const glideLightbox = document.createElement('div')
// 	glideLightbox.classList.add('cipt-wp-gallery__lightbox')
// 	glideEl.appendChild(glideLightbox)

// 	let glideLightboxSlider = null

// 	// Add lightbox click
// 	const glideSliderImgs = glideSlides.querySelectorAll('img')
// 	Array.prototype.forEach.call( glideSliderImgs, function( element, index ) {
// 		const lightboxLinkTarget = element.getAttribute('data-link')
// 		if ( lightboxLinkTarget ) {
// 			element.addEventListener( 'click', ( e ) => {
// 				e.preventDefault()
// 				// console.log('lightbox img clicked')
// 				glideLightboxSlider = openWpBlockGalleryLightboxSlider( glideInnerContainer, glideLightboxSlider, glideLightbox, html, index )
// 			})
// 		}
// 	})

// 	// #3 Mount slider
// 	glide.mount()
// }

// function openWpBlockGalleryLightboxSlider( glideInnerContainer, glideLightboxSlider, glideLightbox, html, startId ) {
// 	html.classList.add('prevent-scroll')
// 	glideLightbox.classList.add('cipt-wp-gallery__lightbox--active')

// 	if ( null !== glideLightboxSlider ) {
// 		glideLightboxSlider.enable()
// 		glideLightboxSlider.go('=' + startId)
// 	} else {
// 		glideLightboxSlider = createWpBlockGalleryLightboxSlider( glideInnerContainer, glideLightboxSlider, glideLightbox, html, startId )
// 	}

// 	return glideLightboxSlider
// }


// function createWpBlockGalleryLightboxSlider( glideInnerContainer, glideLightboxSlider, glideLightbox, html, startId ) {
// 	// console.log( 'prepare lightbox ')
// 	const glideLightboxSliderEl = glideInnerContainer.cloneNode(true)
// 	glideLightbox.appendChild(glideLightboxSliderEl)

// 	const lightboxClose = document.createElement('button')
// 	lightboxClose.setAttribute('aria-label', 'Close lightbox')
// 	lightboxClose.setAttribute('type', 'button')
// 	lightboxClose.classList.add('cipt-wp-gallery__lightbox__close')
// 	// const linkTextlightboxClose = document.createTextNode('<svg class="svg svg-icon" viewbox="0 0 30 30" preserveAspectRatio="xMidYMid meet"><use xlink:href="#mabo-close"></use></svg>')
// 	const iconClose = parser.parseFromString( getSVGIconString('close'), "image/svg+xml").documentElement;
// 	lightboxClose.appendChild(iconClose)
// 	glideLightboxSliderEl.appendChild(lightboxClose)

// 	glideLightboxSlider = new Glide(glideLightboxSliderEl, {
// 		type: 'slider',
// 		dragThreshold: 120,
// 		startAt: startId,
// 		perView: 1,
// 		focusAt: 0,
// 		bound: true,
// 		gap: 14,
// 		perTouch: 1,
// 		rewind: true,
// 		// animationDuration: 200,
// 		// rewindDuration: 400,
// 		peek: {
// 			before: 0,
// 			after: 0
// 		},
// 		throttle: 25,
// 		breakpoints: {
// 			760: {
// 				dragThreshold: 120,
// 			},
// 		},
// 		classes: {
// 			direction: {
// 				ltr: 'cipt-wp-gallery--ltr',
// 				rtl: 'cipt-wp-gallery--rtl'
// 			},
// 			slider: 'cipt-wp-gallery--slider',
// 			carousel: 'cipt-wp-gallery--carousel',
// 			swipeable: 'cipt-wp-gallery--swipeable',
// 			dragging: 'cipt-wp-gallery--dragging',
// 			cloneSlide: 'cipt-wp-gallery__slide--clone',
// 			activeNav: 'cipt-wp-gallery__bullet--active',
// 			activeSlide: 'cipt-wp-gallery__slide--active',
// 			disabledArrow: 'cipt-wp-gallery__arrow--disabled'
// 		}
// 	})

// 	// Start with slide #0: don't show the left arrow
// 	glideLightboxSlider.on('mount.after', function() {
// 		if ( 0 === glideLightboxSlider.index ) {
// 			glideLightboxSliderEl.classList.add('at-first-slide', 'lightbox-at-first')
// 		} else {
// 			glideLightboxSliderEl.classList.remove('at-first-slide', 'lightbox-at-first')
// 		}
// 	})
// 	glideLightboxSlider.on('run.after', function() {
// 		if ( 0 === glideLightboxSlider.index ) {
// 			glideLightboxSliderEl.classList.add('at-first-slide', 'lightbox-at-first')
// 		} else {
// 			glideLightboxSliderEl.classList.remove('at-first-slide', 'lightbox-at-first')
// 		}
// 	})

// 	glideLightboxSlider.mount()

// 	lightboxClose.addEventListener( 'click', ( e ) => {
// 		e.preventDefault()
// 		closeWpBlockGalleryLightboxSlider( glideLightboxSlider, glideLightbox, glideLightboxSliderEl, html )
// 	})

// 	glideLightbox.addEventListener( 'click', ( e ) => {
// 		if ( e.target === e.currentTarget ) {
// 			e.preventDefault()
// 			closeWpBlockGalleryLightboxSlider( glideLightboxSlider, glideLightbox, glideLightboxSliderEl, html )
// 		}
// 	})

// 	return glideLightboxSlider
// }

// function closeWpBlockGalleryLightboxSlider( glideLightboxSlider, glideLightbox, glideLightboxSliderEl, html ) {
// 	html.classList.remove('prevent-scroll')
// 	glideLightbox.classList.remove('cipt-wp-gallery__lightbox--active')
// 	glideLightboxSliderEl.classList.remove('at-first-slide')
// 	glideLightboxSlider.disable()
// }

